var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Model, Timestamp } from '@1amageek/ballcap';
/**
 * サブスクリプションの試用利用の状態
 */
export class TrialSubscription extends Model {
    static fromNewCreate(trialDays, startAt, endAt) {
        const item = new TrialSubscription();
        item.trialDays = trialDays;
        item.startAt = Timestamp.fromDate(startAt);
        item.endAt = Timestamp.fromDate(endAt);
        return item;
    }
}
__decorate([
    Field,
    __metadata("design:type", Number)
], TrialSubscription.prototype, "trialDays", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp
    // 初回試用終了日
    )
], TrialSubscription.prototype, "startAt", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp)
], TrialSubscription.prototype, "endAt", void 0);
